<template>
  <div>
    <div class="row form-group">
      <div class="col-md-7">
        <ts-loading-banner :loading="loading">
          <label class="col-form-label control-label required">{{
            $t('user.branch')
          }}</label>
          <div
            id="branch-group"
            class="ts-border ts-border-gray-300 ts-rounded"
            :class="{ 'ts-border-red-500': errors.has('branches') }"
          >
            <ul class="ts-reset ts-px-4 ts-py-2 ts-h-full">
              <li
                v-for="(record_branches, index) in groupBy(
                  branches,
                  'company_id'
                )"
                :key="index"
              >
                <p class="text-success ts-font-bold">
                  &bull; {{ record_branches[0].company.company_name_en }}
                </p>
                <ul class="ts-reset ts-px-6 ts-mb-4 ts-h-full">
                  <li v-for="branch in record_branches" :key="branch.branch_id">
                    <div class="ts-flex ts-justify-between ts-items-center">
                      <ts-checkbox
                        :checkedValue="Object.keys(model.branches)"
                        @change="setBranches"
                        :value="`${branch.branch_id}`"
                        >{{ branch.branch_name_en }}</ts-checkbox
                      >
                      <div
                        class="custom-control custom-switch"
                        style="padding-top: 3px"
                        v-if="
                          Object.keys(model.branches).includes(
                            `${branch.branch_id}`
                          )
                        "
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          v-model="model.branches[branch.branch_id].is_default"
                          @input="
                            event => setAsDefaultBranch(branch.branch_id, event)
                          "
                          :id="`customSwitchBranch-${branch.branch_id}`"
                        />
                        <label
                          class="custom-control-label"
                          :for="`customSwitchBranch-${branch.branch_id}`"
                        ></label>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="validate" v-if="errors.has('branches')">
            {{ errors.first('branches') }}
          </div>
        </ts-loading-banner>
      </div>
      <div class="col-md-5">
        <ts-loading-banner :loading="loadingLocation">
          <label
            class="col-form-label control-label"
            :class="{ required: edit_data.cashier_location_id }"
            >{{ $t('user.warehouseLocation') }}</label
          >
          <div
            id="branch-group"
            class="ts-border ts-border-gray-300 ts-rounded"
            :class="{ 'ts-border-red-500': errors.has('location_id') }"
          >
            <ul class="ts-reset ts-px-4 ts-py-2 ts-h-full">
              <li v-for="item in warehouses" :key="item.location_id">
                <div class="radio radio-css">
                  <input
                    v-model.number="model.cashier_location_id"
                    type="radio"
                    :id="`${item.location_id}`"
                    :value="`${item.location_id}`"
                  />
                  <label :for="`${item.location_id}`">
                    {{
                      item.location_name +
                        (item.is_main_warehouse ? ' (Is Main)' : '')
                    }}
                  </label>
                </div>
              </li>
            </ul>
          </div>
          <div class="validate" v-if="errors.has('location_id')">
            {{ errors.first('location_id') }}
          </div>
        </ts-loading-banner>
      </div>
    </div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { transform } from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'branchComponent',
  props: ['value', 'validate'],
  data () {
    return {
      loading: false,
      loadingLocation: false,
      errors: new Errors(),
      branches: [],
      model: {}
    }
  },
  created () {
    this.model = this.value
    this.fetchBranch()
  },
  computed: {
    ...mapState('user', ['warehouses', 'edit_data'])
  },
  methods: {
    ...mapActions('user', ['getWarehouse']),
    fetchBranch () {
      this.loading = true
      this.$store
        .dispatch('user/getBranch')
        .then(response => {
          this.branches = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setBranches (branches) {
      this.model.branches = transform(
        branches,
        (result, branchId) => {
          result[branchId] = {
            is_default: this.model.branches[branchId]
              ? this.model.branches[branchId].is_default
              : false
          }
        },
        {}
      )
    },
    fetchLocation (branch_id) {
      this.$store.commit('user/SET_WAREHOUSE_LIST', [])
      this.loadingLocation = true
      this.getWarehouse({
        branch_id: [branch_id]
      })
        .then(() => {
          this.loadingLocation = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loadingLocation = false
        })
    },
    setAsDefaultBranch (branchId, event) {
      Object.keys(this.model.branches)
        .filter(bKey => bKey != branchId)
        .forEach(bKey => {
          this.$set(this.model.branches[bKey], 'is_default', false)
        })

      this.$set(
        this.model.branches[branchId],
        'is_default',
        event.target.checked
      )
      this.$forceUpdate()
      this.model.cashier_location_id = null
      this.fetchLocation(branchId)
    },
    groupBy (array, key) {
      const result = {}
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
        }
        result[item[key]].push(item)
      })
      return result
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
#branch-group {
  height: 180px;
  overflow-y: scroll;
}
</style>
